var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column",style:(`gap: ${_vm.gapInPx}`)},[(!!_vm.content)?_vm._l((_vm.content),function(item,i){return _c('form-node',_vm._g(_vm._b({key:_vm.contentKeys[i]},'form-node',item,false),_vm.$listeners))}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }